import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2019 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

/**
 * Description of a helpfile local to the application, used for things like the help menu.
 */
export class AbHelpFile {
  constructor(relativePath, label, icon) {
    /**
     * the path to the help file, relative to the locale-specific help file location,
     * which is currently <code>$AppContext/ab-help/$locale</code>
     * (see <code>getLocalHelpUrl</code> in <code>OnlineHelpService.java</code>
     */
    _defineProperty(this, "_relativePath", void 0);
    /**
     * The label to show on help menus, buttons, etc
     */
    _defineProperty(this, "_label", void 0);
    /**
     * The icon to display on help menus, buttons, etc. Default: <code>ab:document_dog_ear</code>
     */
    _defineProperty(this, "_icon", void 0);
    this._relativePath = relativePath;
    this._label = label;
    this._icon = icon;
  }

  /**
   * the path to the help file, relative to the locale-specific help file location,
   * which is currently <code>$AppContext/ab-help/$locale</code>
   * (see <code>getLocalHelpUrl</code> in <code>OnlineHelpService.java</code>
   */
  get relativePath() {
    return this._relativePath;
  }

  /**
   * The label to show on help menus, buttons, etc
   */
  get label() {
    return this._label;
  }

  /**
   * The icon to display on help menus, buttons, etc. Default: <code>ab:document_dog_ear</code>
   */
  get icon() {
    return this._icon ? this._icon : "absdk:object-std-file-text";
  }
}
//# sourceMappingURL=AbHelpFile.js.map
